<template>

    <v-content>
        <v-container fluid>

            <panelcontainer>
                <div class="headline" slot="headline">Teklifler / {{this.offer_type.toUpperCase()}}</div>
                <div slot="actions">
                    <v-btn tile color="indigo" dark @click="editItem()">
                        <v-icon>{{mdiPlus}}</v-icon> Yeni Teklif Ekle
                    </v-btn>
                </div>
               
 
				<table class="table table-striped table-borderless table-hover">
					<thead>
						<tr>
							<th>
								<v-text-field v-model="search_title" outlined dense clearable hide-details :label="empty_label" placeholder="Ara" x-small></v-text-field>
							</th>
							<th>
								<v-autocomplete v-if="getAuth.isAdmin" v-model="search_user_id" :items="users" item-value="id" item-text="fullname" :label="empty_label" outlined hide-details="" dense></v-autocomplete>
							</th>
							<th colspan="5"></th> 
						</tr>
						<tr>
							<th>Başlık</th>
							<th v-if="getAuth.isAdmin">Kullanıcı/Firma</th>
							<th>Düzenleme Tarihi</th>
							<th>Geçerlilik Tarihi</th>
							<th class="text-center" v-if="getAuth.isAdmin">Görüldü</th>
							<th class="text-center">Onaylandı</th> 
							<th width="1px" class="actions"></th>
							<th width="1px" class="actions"></th>
							<th width="1px" class="actions"></th>
						</tr>
					</thead>
					<tbody class="no-border-x">
						<tr v-if="isLoading" >
							<td colspan="7"><loading text="Sipariş listesi yükleniyor..." size="80" width="2" /></td>
						</tr>
						<template v-if="!isLoading">
						<tr v-for="(item, itemIndex) in items" :key="itemIndex">
							<td class="cell-detail">
								<span><b>{{item.title}} </b> </span> 
								<span class="cell-detail-description">{{ item.date_add * 1000  | moment("DD.MM.YYYY hh:mm") }}</span> 
							</td>
							<td class="cell-detail" v-if="getAuth.isAdmin">
								<span><b>{{item.user.fullname}}</b></span>
								<span class="cell-detail-description">{{item.user.email}}</span>
							</td>
							<td class="cell-detail">
								<span>{{ item.date_edit * 1000  | moment("DD.MM.YYYY") }}</span>
								<span class="cell-detail-description">{{ item.date_edit * 1000  | moment("dddd") }}</span>
							</td>
							<td class="cell-detail">
								<span>{{ item.date_end * 1000  | moment("DD.MM.YYYY") }}</span>
								<span class="cell-detail-description">{{ item.date_end * 1000  | moment("dddd") }}</span>
							</td> 
							<td class="text-center" v-if="getAuth.isAdmin">
								<v-icon color="green" v-if="item.seen">{{mdiEyeCheck}}</v-icon>
							</td>
							<td class="text-center"> 
								<v-icon color="green" v-if="item.accept">{{mdiAccountCheck}}</v-icon>
							</td>
							<td class="actions">
								<v-btn small icon color="green" dark dense @click="askForCopy(item)"> <v-icon>{{mdiContentCopy}}</v-icon> </v-btn>
							</td>
							<td class="actions">
								<v-btn small icon color="indigo" dark dense @click="editItem(item)"> <v-icon>{{mdiSquareEditOutline}}</v-icon> </v-btn>
							</td>
							<td class="actions">
								<v-btn small icon color="error" dark dense @click="askForRemove(item)"> <v-icon>{{mdiCloseCircle}}</v-icon> </v-btn>
							</td>
						</tr>
						</template>
					</tbody>
				</table>
				<v-row justify="center  p-0" v-if="count_page > 0">
					<v-col cols="8 pa-0">
						<v-container class="max-width  pa-0">
							<v-pagination v-model="page" class="mb-4" :length="count_page" :total-visible="8" color="red"></v-pagination>
						</v-container>
					</v-col>
				</v-row> 
            </panelcontainer>

            <v-layout row>

 



                <v-dialog v-model="dialogRemove" max-width="350">
                    <v-card>
                        <v-card-title class="headline" color="error"> Sil</v-card-title>
						<v-card-text><b>{{item.title}}</b> başlıklı içeriği silmek itediğine emin misin ?</v-card-text>
                        <v-card-actions>
                            <v-btn color="green darken-1" text @click="closeForRemove()"> Vazgeç </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="error darken-1" text @click="removeItem()"> EMİNİM </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="dialogCopy" max-width="350">
                    <v-card>
                        <v-card-title class="headline" color="error">Kopyala</v-card-title>
						<v-card-text>
							<b>{{item.title}}</b> başlıklı içeriğin bir kopyasını oluştur
							<br>
							<br>
							<v-text-field v-model="itemCopy.title" outlined dense hide-details label="Bir başlık belirle"  x-small></v-text-field>
						</v-card-text>
                        <v-card-actions>
                            <v-btn color="green darken-1" text @click="closeForCopy()"> Vazgeç </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="error darken-1" text @click="copyItem()"> EMİNİM </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>





            </v-layout>
        </v-container>
    </v-content>


</template>


<script>
    import loading from "@/components/utils/loading"
    import panelcontainer from "@/components/utils/panelcontainer"
    import {
        mdiPlus,
        mdiCloseCircle,
        mdiBellCheck,
        mdiTimerSand,
        mdiEmailSend,
        mdiSquareEditOutline,
        mdiContentCopy,
        mdiEyeCheck,
        mdiAccountCheck,
    } from '@mdi/js';
    export default {
        components: {
            loading,
            panelcontainer,
        },
        data: () => ({
            mdiPlus: mdiPlus,
            mdiCloseCircle: mdiCloseCircle,
            mdiBellCheck: mdiBellCheck,
            mdiTimerSand: mdiTimerSand,
            mdiEmailSend: mdiEmailSend,
            mdiSquareEditOutline: mdiSquareEditOutline,
            mdiContentCopy: mdiContentCopy,
            mdiEyeCheck: mdiEyeCheck,
            mdiAccountCheck: mdiAccountCheck,

            appLoaded: false,
            isLoading: true,
			dialogRemove: false, 
            dialogCopy: false,

			users : [],
			
			search_title : "",
			search_user_id : 0,
			search_unique : 0,
			
            count_total: 0,
            count_page: 0,
            page: 1,
			items: [ ], 
			item : {},
			itemCopy : {},
			empty_label : "",
			statusColor : {
				"Reddedildi" : "danger",
				"İptal Edildi" : "orange",
				"Bekliyor" : "",
				"Onaylandı" : "green",
			}
		}),
		watch : {
			search_title : function(n){
				this.loadItemsForSearch()
			},
			search_user_id : function(n){
				this.loadItemsForSearch()
			},
			page : function(n){
				this.loadItems()
			},
			offer_type : function(n){
				this.loadItems()
			},
		},
		mounted(){ 
			this.loadUsers()  
			this.loadItems() 
		},
        methods: {
			loadUsers(){
				this.$http.get( process.env.VUE_APP_API_URL + "/users/shared", {
					params : { }
				}).then(response => {
					response.body.unshift({id : "",fullname :"Tümü"})
					this.users = response.body;  
				}) 
			},
			loadItemsForSearch(){ 
				if(this.appLoaded){
					this.loadItems();
				}
			},
			loadItems(){
				this.appLoaded = true;
				this.isLoading = true;
				var newUnique = Math.floor(Math.random() * 1000)
				this.search_unique = newUnique
				this.$http.get( process.env.VUE_APP_API_URL + "/offers/", {
					params : {
						offer_type : this.offer_type,
						search_title : this.search_title,
						search_user_id : this.search_user_id,
						page : this.page,
					}
				}).then(response => {  
					if(newUnique == this.search_unique){
						this.count_total = response.body.count_total; 
						this.count_page = response.body.count_page;  
						this.items = response.body.list; 
						this.isLoading = false; 
						this.dialogRemove = false;
						this.dialogCopy = false;
					}
				})  
			},
            editItem(item) {
				var link = "/offers/"+this.offer_type+"/edit/"
				if(item){
					link += "?id=" + item.id
				} 
				window.open(link, '_blank'); 
			}, 
			askForRemove(item){
				this.item = JSON.parse(JSON.stringify(item))
				this.dialogRemove = true;
			},
			removeItem(item){
				this.$http.post( process.env.VUE_APP_API_URL + "/offers/remove", this.item).then(response => {  
					this.loadItems()
					this.dialogRemove = false;
				})
			},
			closeForRemove(){
				this.dialogRemove = false;
			},
			askForCopy(item){
				this.item = JSON.parse(JSON.stringify(item))
				this.item.title += " Kopyası"
				this.itemCopy = JSON.parse(JSON.stringify(this.item))
				this.dialogCopy = true;
			},
			copyItem(item){
				this.$http.post( process.env.VUE_APP_API_URL + "/offers/copy", this.itemCopy).then(response => {  
					this.loadItems()
				this.dialogCopy = false;
				}) 
			}, 
			closeForCopy(){
				this.dialogCopy = false;
			},
        },
		computed:{
			offer_type(){
				return this.$route.params.offer_type;
			},
			getAuth(){
				return this.$store.getters.getAuth;
			}
		}
    }
</script>

<style>

</style>